import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const useStyles = makeStyles((theme) => ({
  grid: {
    padding: theme.spacing(1),
    alignSelf: "center",
  },
}));

const TeamCoordinator = (props) => {
  const classes = useStyles();

  const [isCoordinator, setIsCoordinaor] = useState(props.data);

  useEffect(() => {
    props.onChange(isCoordinator);
  }, [isCoordinator]);

  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 12 }} className={classes.grid}>
        <RadioGroup
          row
          aria-label="coordinator"
          name="isCoordinator"
          value={isCoordinator}
          onChange={(event) => setIsCoordinaor(event.target.value)}
        >
          <FormControlLabel
            value="no"
            control={<Radio color="secondary" />}
            color="secondary"
            label={<Typography variant="caption">No</Typography>}
          ></FormControlLabel>
          <FormControlLabel
            value="offensive"
            control={<Radio color="secondary" />}
            label={
              <Typography variant="caption">
                Yes, Offensive Coordinator
              </Typography>
            }
          />
          <FormControlLabel
            value="defensive"
            control={<Radio color="secondary" />}
            label={
              <Typography variant="caption">
                Yes, Defensive Coordinator
              </Typography>
            }
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
};

export default TeamCoordinator;
